/**
 * Add components by event and in your desired order
 * @type {[*]}
 */
let components = [
    ['ready', [
        require('./../lib/equalHeights'),
        require('./../components/awards-slider'),
        require('./../components/cookie-notice'),
        require('./../components/cta-bar'),
        require('./../components/faq'),
        require('./../components/filter'),
        require('./../components/form'),
        require('./../components/form-styling'),
        require('./../components/general'),
        require('./../components/header'),
        require('./../components/keyvisual'),
        require('./../components/overlay'),
        require('./../components/popup'),
        require('./../components/parallax'),
        require('./../components/pricing-features'),
        require('./../components/pricing-slider'),
        require('./../components/solution-scroller'),
        require('./../components/scrolled-page'),
        require('./../components/scroller'),
        require('./../components/trigger'),
        require('./../components/scroll-menu'),
        require('./../components/scroller'),
        require('./../components/slider'),
        require('./../components/solution-slider'),
        require('./../components/waypoints'),
        require('./../components/resources-filter'),
    ]],
];

module.exports = components;
